// extracted by mini-css-extract-plugin
export default {"skillBlock":"Skill_skillBlock__1VQq8","icon":"Skill_icon__9+l+O"};